export default "__VITE_ASSET__Bfrezy0o__"